
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 24 24\" id=\"embed\" ><defs/><title>embed</title><g id=\"embed_Layer_2\" data-name=\"Layer 2\"><g id=\"embed_Icons\"><path class=\"cls-1\" d=\"M12 24a12 12 0 1 1 12-12 12 12 0 0 1-12 12zm0-23a11 11 0 1 0 11 11A11 11 0 0 0 12 1z\" id=\"embed_facebook\"/><g id=\"embed_email\"><path class=\"cls-1\" d=\"M8.72 15l-3.08-3 3.08-3 .8.84-2.27 2.24 2.26 2.13zM11.2 17.56h-1l2.7-10.71h1zM15.57 15l-.81-.86L17 12l-2.24-2.1.81-.82 3.07 3z\"/></g></g></g></symbol>";
module.exports = sprite.add(image, "embed");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/embed.svg
// module id = 650
// module chunks = 1474